import classnames from "classnames";
import { ContextualMenu, ContextualMenuItemType, Icon } from "@fluentui/react";
import React from "react";
import "./ActionMenu.scss";

import { Label } from "src/components/Label/Label";
import * as Style from 'src/utils/style';
import { localize } from "src/utils/l10n";
import Visage2Icon from "../Visage2Icon/Visage2Icon";

interface IActionMenuItem {
    icon?: string;
    key?: string;
    text: string;
    onClick?: () => void;
    href?: string;
    subMenuProps?: any;
    canCheck?: boolean;
    isChecked?: boolean;
}

interface IActionMenuCategory {
    title?: string;
    items: IActionMenuItem[];
}

interface IProps {
    categories: IActionMenuCategory[];
    icon?: string;
    label?: string;
    isOpen?: boolean;
    onMenuDismissed?: any;
    iconColor?: string;
    gapSpace?: number;
    disableHoverEffect?: boolean;
    renderButton?: any;
    labelColor?: spintrColors;
    menuClassName?: string;
}

interface State {
    visible: boolean;
    hasBeenVisible: boolean;
}

const convertCategoriesToMenuItems = (categories) => {
    let menuItems = [];

    for (let c of categories) {
        if (c.title) {
            menuItems.push({
                key: "k" + categories.indexOf(c),
                text: c.title,
                itemType: ContextualMenuItemType.Header,
            });
        }

        for (let ci of c.items) {
            menuItems.push({
                key: ci.key || ci.text,
                onClick: ci.onClick,
                href: ci.href,
                text: ci.text,
                ...(ci.icon ? { iconProps: { iconName: ci.icon } } : null),
                onRenderIcon: ci.onRenderIcon,
                canCheck: ci.canCheck,
                isChecked: ci.isChecked,
                subMenuProps: ci.subMenuProps,
                className: ci.className,
                disabled: ci.disabled
            });
        }
    }

    return menuItems;
};

class ActionMenu extends React.Component<IProps, State> {
    private rootClassname = "actionmenu-component";
    private linkRef = React.createRef<any>();

    state = {
        visible: false,
        hasBeenVisible: false
    };

    onShowContextualMenu = (e) => {
        e.stopPropagation();
        this.setState({ visible: !this.state.visible, hasBeenVisible: true });
    };

    onHideContextualMenu = () => {
        this.setState({
            visible: false
        }, () => {
            if (this.props.onMenuDismissed) {
                this.props.onMenuDismissed();
            }
        });
    };

    onKeyDown = (e) => {
        if ([13, 32].some((k) => e.keyCode === k)) {
            this.onShowContextualMenu(e);
        }
    };

    render() {
        return (
            <a
                title={localize("VisaAlternativ")}
                onKeyDown={this.onKeyDown}
                tabIndex={0}
                ref={this.linkRef}
                onClick={this.onShowContextualMenu}
                className={classnames(`${this.rootClassname}`, "print-ignore", { "open": this.state.visible, "hover-effect": !this.props.disableHoverEffect })}
            >
                {
                    !this.props.renderButton && this.props.label && (
                        <Label as="span" size="body-3" color={this.props.labelColor ? this.props.labelColor : "p-dark-grey-1"}>
                            {this.props.label}
                        </Label>
                    )
                }
                {
                    this.props.renderButton && this.props.renderButton()
                }
                {
                    !this.props.renderButton && !!this.props.icon && (
                        <Icon
                            iconName={this.props.icon ? this.props.icon : "More"}
                            style={!this.props.iconColor ? {} : {
                                color: this.props.iconColor
                            }} />
                    )
                }
                {
                    !this.props.renderButton && !this.props.icon && (
                        <Visage2Icon icon="more-square" type="outline" size="extra-big" hexColor={this.props.iconColor ? this.props.iconColor : Style.getHexFromSpintrColor("p-mid-grey-3")} />
                        // <Icon
                        //     iconName={this.props.icon ? this.props.icon : "More"}
                        //     style={!this.props.iconColor ? {} : {
                        //         color: this.props.iconColor
                        //     }} />
                    )
                }
                {
                    !!this.state.hasBeenVisible && (
                        <ContextualMenu
                            items={convertCategoriesToMenuItems(this.props.categories)}
                            hidden={!this.state.visible}
                            target={this.linkRef}
                            onItemClick={this.onHideContextualMenu}
                            gapSpace={this.props.gapSpace}
                            onDismiss={this.onHideContextualMenu}
                            className={this.props.menuClassName}
                        />
                    )
                }
            </a>
        );
    }
}

export default ActionMenu;
